import {createRootContextHook} from 'common/util/react';

export const useLocalStorageManager = createRootContextHook(`localStorageManager`);
export const useSessionStorageManager = createRootContextHook(`sessionStorageManager`);
